module.exports = __webpack_public_path__ + "img/phil-pro.dfb2285d.jpg";